import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NavigationStart, Router, RouterEvent } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { filter } from 'rxjs/internal/operators/filter';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-session-modal',
  templateUrl: './session-modal.component.html',
  styleUrls: ['./session-modal.component.scss'],
})
export class SessionModalComponent implements OnInit, OnDestroy {
  _timer = 30;

  private subscriptions: Subscription[] = [];
  constructor(
    public dialogRef: MatDialogRef<SessionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: boolean,
    private router: Router
  ) {}
  ngOnInit() {
    const numbers = interval(1000);

    const timerE = numbers
      .pipe(
        take(this._timer),
        map(i => 29 - i)
      )
      .subscribe(val => {
        this._timer = val;
      });

    this.subscriptions.push(timerE);
    const _routerSubscription = this.router.events
      .pipe(
        filter((event: RouterEvent) => event instanceof NavigationStart),
        filter(() => !!this.dialogRef)
      )
      .subscribe(() => {
        this.dialogRef.close();
      });

    this.subscriptions.push(_routerSubscription);
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
